module.exports = __webpack_public_path__ + "media/images/v2/icon6-c6f2c5b47f029f0254bd6f38d9e47ac1.png";